import React from 'react';
import moment from 'moment';

const ServerTime = ({ api }) => {
    const [hasApiResponse, setHasApiResponse] = React.useState(false);
    const [date, setDate] = React.useState();
    const [dateString, setDateString] = React.useState();

    const updateTime = () => {
        if (!date) return;
        date.setSeconds(date.getSeconds() + 1);
        setDateString(`${moment.utc().format('YYYY-MM-DD HH:mm:ss')  } GMT`)
    };

    const getServerTime = () => {
        api.getServerTime().then(response => {
            const newDate = new Date(response.time * 1000);
            setDate(newDate);
            setHasApiResponse(true);
        });
        // api.send({ time: 1 }).then(response => {
        //     const newDate = new Date(response.time * 1000);
        //     setDate(newDate);
        //     setHasApiResponse(true);
        // });
    };

    React.useEffect(() => {
        getServerTime();

        const updateTimeInterval = setInterval(updateTime, 1000);
        const serverTimeInterval = setInterval(getServerTime, 30000);

        return () => {
            clearInterval(updateTimeInterval);
            clearInterval(serverTimeInterval);
        };
    }, [hasApiResponse]);

    React.useEffect(() => updateTime(), [date]);

    return <b>{dateString}</b>;
};

export default ServerTime;



// WEBPACK FOOTER //
// ./src/botPage/view/react-components/HeaderWidgets.js